<template>
  <v-dialog
    v-model="bankSearchView"
    scrollable
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">銀行名稱查詢</span>
      </v-card-title>
      <v-card-text
    ref="bankSearchView">
        <div class="ml-6 mb-4">
          <div class="bankSelectBox__remind">欲輸入金融機構代號，請輸入關鍵字(如:玉山)，再點選「查詢」後，選擇金融機構名稱填入即可。</div>
          <div class="bankSelectBox__remind">請輸入類別、銀行、縣市、分行相關查詢條件後，請按「確定」按鈕，會出現銀行代號相關資料。</div>
          <div class="bankSelectBox__remind">帳戶如為郵局，縣市一律選擇臺北市，分行為郵局存簿儲金。</div>
          <div class="bankSelectBox__remind">請點選正確之開戶銀行，即會自動將銀行資料帶回基本資料中。</div>
          <div class="bankSelectBox__remind">若查詢結果中，查無適合之金融代號，請與本校會計室聯絡。電話：07-3426031 分機：1304、1303</div>
        </div>
        <ToggleSearchWrap>
          <template v-slot:container>
            <SearchBox labeltxt="關鍵字" >
              <FormInput v-model.trim="bankSearchViewRequest.keyword" :width="'300px'"></FormInput>
            </SearchBox>
            <SearchBox labeltxt="類別" >
              <DefaultCombobox v-model.trim="bankSearchViewRequest.bankType" :items="bankSearchSelector.bankTypeSelector" :placeholder="'請選擇類別'" :itemText="'label'" :itemValue="'value'" :clearable="true" :width="'300px'"></DefaultCombobox>
            </SearchBox>
            <SearchBox labeltxt="銀行" >
              <DefaultCombobox v-model.trim="bankSearchViewRequest.bankId" :items="bankSearchSelector.bankNameSelector" :placeholder="'請選擇銀行'" :itemText="'label'" :itemValue="'value'" :clearable="true" :width="'300px'"></DefaultCombobox>
            </SearchBox>
            <SearchBox labeltxt="縣市" >
              <DefaultCombobox v-model.trim="bankSearchViewRequest.cityId" :items="bankSearchSelector.bankCitySelector" :placeholder="'請選擇縣市'" :itemText="'label'" :itemValue="'value'" :clearable="true" :width="'300px'"></DefaultCombobox>
              </SearchBox>
            <SearchBox labeltxt="分行" >
              <DefaultCombobox v-model.trim="bankSearchViewRequest.bankOffice" :items="bankSearchSelector.bankOfficeSelector" :placeholder="'請選擇分行'" :itemText="'label'" :itemValue="'value'" :clearable="true" :width="'300px'"></DefaultCombobox>
            </SearchBox>
            <DefaultButton :colorType="'cancel'" class="mt-2 text__size-14" @doFunction="handleClearAll()">
              <span>清除搜尋條件</span>
            </DefaultButton>
            <DefaultButton :colorType="'primary'" class="mt-2 text__size-14" @doFunction="doGetBankSearchData()">
              <span>查詢</span>
            </DefaultButton>
            <!-- 時間軸開啟按鈕，暫時隱藏 -->
          </template>
        </ToggleSearchWrap>
        <div v-if="showSearchResult">
          <div class="mt-4 d-flex flex-column align-center" v-if="bankSearchViewData.length > 0">
            <h2>請點選下列適合的銀行</h2>
            <div class="bankSelectBox">
              <div class="bankSelectBox__group" v-for="(data, index) in bankSearchViewData" :key="index" @click="handleBankSelect(data.bank_account, data.bank_name)">
                <div class="bankSelectBox__item">{{ data.bank_account }}</div>
                <div class="bankSelectBox__item">{{ data.bank_name }}</div>
              </div>
            </div>
          </div>
          <NoData v-if="bankSearchViewData.length === 0" errorMessage="查無資料"></NoData>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="green darken-1"
          text
          @click="bankSearchView = false"
        >
          關閉
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialogTitle: {
      type: [String],
      default() {
        return '查詢';
      },
    },
    value: {
      type: Boolean,
      required: true,
    },
    width: {
      type: String,
      default() {
        return '600px';
      },
    },
    bankNo: {},
    bankName: {},
  },
  data() {
    return {
      bankSearchView: false,
      bankSearchSelector: {
        bankTypeSelector: [],
      },
      bankSearchViewData: [],
      bankSearchViewRequest: {
        keyword: '',
        bankType: null,
        bankId: null,
        cityId: null,
        bankOffice: null,
      },
      showSearchResult: false,
    };
  },
  watch: {
    value(val) {
      this.bankSearchView = val;
      if (val === true) {
        this.handleClearAll();
        this.handleBankSearch();
      }
    },
    bankSearchView(val) {
      this.$emit('input', val);
    },
    'bankSearchViewRequest.bankType': {
      handler(val) {
        this.bankSearchViewRequest.bankId = null;

        this.doLoadBankNameSelectorData(val);
        this.doLoadBankCitySelectorData(val, this.bankSearchViewRequest.bankId);
      },
    },
    'bankSearchViewRequest.bankId': {
      handler(val) {
        this.bankSearchViewRequest.bankOffice = null;
        if (val === null) {
          this.bankSearchViewRequest.cityId = null;
          this.doLoadBankCitySelectorData(this.bankSearchViewRequest.bankType, val);
        } else {
          this.doLoadBankCitySelectorData(this.bankSearchViewRequest.bankType, val).then((res) => {
            if (res.find((x) => x.value === this.bankSearchViewRequest.cityId)) {
              this.doLoadBankOfficeSelectorData(val, this.bankSearchViewRequest.cityId);
            } else {
              this.bankSearchViewRequest.cityId = null;
            }
          });
        }
      },
    },
    'bankSearchViewRequest.cityId': {
      handler(val) {
        this.bankSearchViewRequest.bankOffice = null;
        if (val === null) {
          this.bankSearchSelector.bankOfficeSelector = [];
        } else {
          this.doLoadBankOfficeSelectorData(this.bankSearchViewRequest.bankId, val);
        }
      },
    },
  },
  methods: {
    handleBankSearch() {
      const params = JSON.parse(JSON.stringify(this.bankSearchViewRequest));

      if (this.bankNo && this.bankName) {
        params.bankOffice = this.bankNo;
      }

      this.doLoadBankSearchViewData(params).then((res) => {
        this.bankSearchViewData = res.dataList;
        this.bankSearchSelector = res.selector;
        this.showSearchResult = true;
      });
    },
    handleClearAll() {
      this.showSearchResult = false;
      this.bankSearchViewRequest = {
        keyword: '',
        bankType: null,
        bankId: null,
        cityId: null,
        bankOffice: null,
      };
    },
    handleBankSelect(bankAccount, bankName) {
      this.$emit('update:bankNo', bankAccount);
      this.$emit('update:bankName', bankName);
      this.bankSearchView = false;
    },
    doLoadBankSearchViewData(params) {
      return new Promise((reslove) => {
        $api.common.BankSearchViewLoad(params).then((res) => {
          const { code, data } = res;
          if (code === 200) {
            reslove(data);
          }
        });
      });
    },
    doGetBankSearchData() {
      const params = JSON.parse(JSON.stringify(this.bankSearchViewRequest));

      return new Promise((reslove) => {
        $api.common.GetBankSearchData(params).then((res) => {
          const { code, data } = res;
          if (code === 200) {
            this.showSearchResult = true;
            this.bankSearchViewData = data;
            setTimeout(() => {
              const dom = this.$refs.bankSearchView;
              dom.scrollTo({ top: dom.scrollHeight - dom.clientHeight, behavior: 'smooth' });
            }, 100);
            reslove(data);
          }
        });
      });
    },
    doLoadBankTypeSelectorData(params) {
      return new Promise((reslove) => {
        $api.common.BankTypeSelectorLoad(params).then((res) => {
          const { code, data } = res;
          if (code === 200) {
            this.bankSearchSelector.bankTypeSelector = data;
            reslove(data);
          }
        });
      });
    },
    doLoadBankNameSelectorData(bankType) {
      const params = {
        bankType,
      };
      return new Promise((reslove) => {
        $api.common.BankNameSelectorLoad(params).then((res) => {
          const { code, data } = res;
          if (code === 200) {
            this.bankSearchSelector.bankNameSelector = data;
            reslove(data);
          }
        });
      });
    },
    doLoadBankCitySelectorData(bankType, bankId) {
      const params = {
        bankType,
        bankId,
      };
      return new Promise((reslove) => {
        $api.common.BankCitySelectorLoad(params).then((res) => {
          const { code, data } = res;
          if (code === 200) {
            this.bankSearchSelector.bankCitySelector = data;
            reslove(data);
          }
        });
      });
    },
    doLoadBankOfficeSelectorData(bankId, cityId) {
      const params = {
        bankId,
        cityId,
      };
      return new Promise((reslove) => {
        $api.common.BankOfficeSelectorLoad(params).then((res) => {
          const { code, data } = res;
          if (code === 200) {
            this.bankSearchSelector.bankOfficeSelector = data;
            reslove(data);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>

.bankSelectBox {
  margin: 16px;
  width: 100%;
  overflow-y: auto;
  max-height: 50vh;

  &__remind {
    display: list-item;
    color: #F44336 !important;
    caret-color: #F44336 !important;
  }

  &__group {
    display: flex;
    border: thin solid rgba(0, 0, 0, 0.12);
    text-align: center;
    background-color: rgb(222, 234, 160);
  }

  &__group:hover {
    box-shadow: 2px 2px 1px rgba(251, 150, 110, 0.25);
    background-color: rgb(51, 102, 153);
    color:white;
    cursor: pointer;
  }

  &__item {
    width: 100%;
    padding: 0.5rem;
  }

  &__item:not(:last-child) {
    width: 30%;
    border-right: thin solid rgba(0, 0, 0, 0.12);
  }
}

</style>
